module.exports = __webpack_public_path__ + "static/media/holiday-search.9b9f26e5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/holiday-search.mp4
// module id = 850
// module chunks = 0